import styled from 'styled-components';
import { Box, Button } from '@mui/material';

const blue = '#0d4efe';
const ink = '#1a1a2e';
const muted = '#5a6478';
const line = 'rgba(26, 26, 46, 0.12)';

/** White card that sits inside the page's Mint mist panel. */
export const FilterContainer = styled(Box)`
  display: flex;
  align-items: center;
  padding: 14px 18px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(26, 26, 46, 0.06);
  box-shadow: 0 4px 16px rgba(26, 26, 46, 0.05);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    padding: 14px;
  }
`;

export const FilterRow = styled(Box)`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex: 1;

  .MuiOutlinedInput-root {
    border-radius: 10px;
    background: #f7fafc;
    transition: background 0.15s ease;

    &.Mui-focused {
      background: #ffffff;

      .MuiOutlinedInput-notchedOutline {
        border-color: ${blue};
        border-width: 1.5px;
      }
    }

    .MuiOutlinedInput-notchedOutline {
      border: 1.5px solid ${line};
    }
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 10px;
  }
`;

const secondaryButton = `
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: none;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;

  .MuiSvgIcon-root {
    font-size: 1.1rem;
  }

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

export const FavoritesToggle = styled.button`
  ${secondaryButton}
  margin-left: auto;
  border: 1.5px solid ${({ $active }) => ($active ? blue : line)};
  background: ${({ $active }) => ($active ? 'rgba(13, 78, 254, 0.06)' : '#ffffff')};
  color: ${({ $active }) => ($active ? blue : ink)};

  .MuiSvgIcon-root {
    color: ${({ $active }) => ($active ? blue : muted)};
  }

  &:hover,
  &:focus-visible {
    border-color: ${blue};
    color: ${blue};

    .MuiSvgIcon-root {
      color: ${blue};
    }
  }
`;

export const ClearButton = styled(Button)`
  && {
    ${secondaryButton}
    margin-left: ${({ $hasFavoritesToggle }) => ($hasFavoritesToggle ? '0' : 'auto')};
    border: 1.5px solid ${line};
    background: #ffffff;
    color: ${muted};

    &:hover {
      border-color: ${blue};
      background: #ffffff;
      color: ${blue};
    }
  }
`;
